import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from '../common/PageTitleBanner';

const Projects = () => {
    return (
        <>
            <PageTitle subtitle="Our Work" title="Our Work" bannerImage="assets/images/banner.jpg" />
            <section className="content-section lightbg">
                <Container>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project1.jpeg" alt="" width="500" height="600"/>
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i> Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/1" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project2.jpeg" alt="" width="500" height="600" />
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i> Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/2" className="fulllink">&nbsp;</Link>
                            </div>
                        </div> */}
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project3.jpeg" alt="" width="500" height="600" />
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i>Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/3" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project4.jpeg" alt="" width="500" height="600" />
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i>  Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/4" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project5.jpeg" alt="" width="500" height="600"/>
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i> Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/5" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project6.jpeg" alt="" width="500" height="600" />
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i>  Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/6" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project7.jpeg" alt="" width="500" height="600" />
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i> Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/7" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project8.jpeg" alt="" width="500" height="600" />
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i>  Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/8" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project9.jpeg" alt="" width="500" height="600"/>
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i>  Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/8" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="project-block style-1">
                                <div className="image">
                                    <img src="assets/images/projects/project10.jpeg" alt="" width="500" height="600"/>
                                </div>
                                <div className="project-meta">
                                    <div className="project-title mb-2"> JSW</div>
                                    <div className="project-location"><i className="fas fa-map-pin"></i>  Panvel Maharashtra</div>
                                </div>
                                <Link to="/project/8" className="fulllink">&nbsp;</Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            <section className="content-section">
                <Container>
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="heading heading-md text-center mb-3"><span className="weight-light">Did you love</span> our work?</div>
                            <div className="para-txt txt-large text-center mb-5">
                                <p>
                                    In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without
                                </p>
                            </div>
                            <div className="text-center">
                                <Link to="/contact" className="button">Get A Quote</Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

        </>
    )
}
export default Projects;